export default __webpack_public_path__ + "media/save-memories.347773b6.png";